<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="$resourceLoading()">
  <ng-container page-return> <unity-action-shared [action]="$returnToDashboardAction()" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    @let createUserAction = $createUserAction();
    @if (!!createUserAction) {
      <unity-action-shared [action]="createUserAction" />
    }
    <unity-workflow-selector-shared
      [transitions]="$availableTransitions()"
      [disabled]="$workflowActionsDisabled()"
      (workflowEvent)="onWorkflow($event)" />
  </ng-container>

  @let formGroup = $formGroup();
  <unity-panel-manage-shared
    [resource]="$resource()"
    [resourceName]="resourceName"
    [formGroup]="formGroup"
    [isEditable]="$isEntitledToEdit()"
    [submitLoading]="$updateLoading()"
    (detailEditEvent)="toggleWorkflowActions($event)"
    (saveEvent)="onSave()">
    <unity-form-layout>
      <unity-textbox-control displayName="Name" description="Provide the business partner name." [control]="formGroup.controls.name" />
      <unity-textbox-control
        displayName="Code"
        description="Provide the business partner code (e.g. ABH)."
        [control]="formGroup.controls.code" />
      <unity-multiselect-community-control
        description="Select the communities that this business partner serves."
        [control]="formGroup.controls.community_ids" />

      <unity-textbox-control
        displayName="Point of Contact"
        description="Provide the point of contact."
        [control]="formGroup.controls.contact" />
      <unity-textbox-control displayName="Contact Email" description="Provide the contact email." [control]="formGroup.controls.email" />
      <unity-textbox-control
        displayName="Contact Phone"
        description="Provide the contact phone number."
        mask="(000) 000-0000"
        [control]="formGroup.controls.phone" />
    </unity-form-layout>
  </unity-panel-manage-shared>
  @let agencyId = $resource()?.id;
  @if (!!agencyId) {
    <unity-grid-agency-user-shared *unityAuthorize="'AgencyUser:List'" [agencyId]="agencyId" />
  }
  <unity-grid-agency-role-shared *unityAuthorize="'Role:List'" [agencyId]="agencyId" />
</unity-page-container>
